const hasEntranceAnimation = (animation) => animation?.type === "VIEW" && Boolean(animation.entrance?.effect);
export {
  hasEntranceAnimation
};
//# sourceMappingURL=has-entrance-animation.js.map
